export class SeriesList {
  series_id: number;
  series_name: string;
  sequence_number: number;
  modules: Array<[]>;
}
